import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseCell } from '@warrenbrasil/nebraska-web';

interface Props {
  risk: { formatted: string; color: string } | null;
  align?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RiskCell',
  props: {
    risk: { default: null },
    align: { default: 'right' }
  },
  setup(__props: any) {

const { risk } = __props as { risk: { formatted: string; color: string } | null, align: string };



const bulletStyle = computed(() => {
  return { backgroundColor: risk?.color };
});

return { __sfc: true,risk, bulletStyle, BaseCell }
}

})